export default function CountdownTimer({ className = '', parts }) {
  const values = [
    ['days', 'Days'],
    ['hours', 'Hrs'],
    ['minutes', 'Min'],
    ['seconds', 'Sec'],
  ]

  return (
    <div className={`market-countdown ${className}`.trim()} aria-label="Auction countdown">
      {values.map(([key, label]) => (
        <span key={key}>
          <strong>{parts[key]}</strong>
          <small>{label}</small>
        </span>
      ))}
    </div>
  )
}
